export enum FixedActionType {
  USER_CUSTOM_STATUS_SET = 'USER_CUSTOM_STATUS_SET',
  ORG_CUSTOM_STATUS_SET = 'ORG_CUSTOM_STATUS_SET',
  APPOINTMENT_BOOKED = 'APPOINTMENT_BOOKED',
}
